export function dispersedMatch(search: string, target: string): boolean {
    const s = search.toLowerCase();
    const t = target.toLowerCase();
    let searchIndex = 0;
    let targetIndex = 0;
    while (searchIndex < s.length && targetIndex < t.length) {
        if (s[searchIndex] === t[targetIndex]) {
            searchIndex++;
        }
        targetIndex++;
    }
    return searchIndex === s.length;
}
